import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { inject as controller } from '@ember/controller';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import IntegrationsFormsController from 'cio/pods/integrations/forms/controller';
import { FormIntegrationDetailPanes } from 'cio/components/forms/custom/integration-details';
import { FormType } from 'cio/utils/forms';
import CustomFormsService from 'cio/services/custom-forms';
import AuthService from 'cio/services/auth';
import AdBlockerService from 'cio/services/ad-blocker';

export default class IntegrationsFormsGeneralSettingsController extends Controller {
  @service auth!: AuthService;
  @service adBlocker!: AdBlockerService;
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;

  @controller('integrations/forms') baseController!: IntegrationsFormsController;

  readonly FormType = FormType;
  readonly FormIntegrationDetailPanes = FormIntegrationDetailPanes;

  get isFacebookDisabled() {
    return (
      !this.auth.hasPermission('journeys/forms/create') ||
      !this.facebookLeadAds.isAvailable ||
      this.adBlocker.isFacebookBlocked
    );
  }

  integrationDetailPanes = [
    {
      title: 'API endpoint',
      key: FormIntegrationDetailPanes.FormsEndpoint,
    },
    {
      title: 'Form action attribute',
      key: FormIntegrationDetailPanes.HTMLAction,
    },
    {
      title: 'JS snippet',
      key: FormIntegrationDetailPanes.JavaScriptSnippet,
    },
  ];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'integrations/forms/general/settings': IntegrationsFormsGeneralSettingsController;
  }
}
